'use strict';

export default class Modal {
	constructor($e) {
		this._$e = $e;
		this._target = $e.attr('data-target');
		this._$target = $(this._target);
		this._$e.on('click', (e) => this.modalOpen(e));
		this._$target.on('click', () => this.modalClose());
		this._$target.find('[data-dismiss=modal]').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog__content').on('click', (e) => {
			e.stopPropagation();
		});
	}

	getData(name) {
		return this._$e.data(name);
	}

	getLabel(value, labels) {
		return labels[String(value)] || '';
	}

	modalOpen(e) {
		e.preventDefault();
		const isComingSoon = this.getData('coming-soon') === true || this.getData('coming-soon') === 'true';
		const coeducation = this.getLabel(this.getData('coeducation'), {
			1: '男子校',
			2: '女子校',
			3: '共学',
			4: '男子校 (2026年度から共学)',
		});
		const curriculum = this.getLabel(this.getData('curriculum'), {
			1: 'Aレベル',
			2: 'IBDP',
			3: 'Aレベル & IBDP',
			4: 'n/a',
		});

		$('body').css('overflow', 'hidden');
		this._$target.toggleClass('is-coming-soon', isComingSoon);
		$('#modal-logo').attr({
			src: this.getData('logo-url'),
			alt: this.getData('name-en'),
		});
		const imageUrlSp = this.getData('image-url-sp') || '';
		const imageUrlPc = this.getData('image-url-pc') || '';
		$('#modal-url-sp').attr('srcset', imageUrlSp);
		$('#modal-url-pc').attr({
			src: imageUrlPc,
			alt: this.getData('name-en'),
		});
		this._$target.toggleClass('has-main-image', !!imageUrlPc);
		$('#school-name-ja').text(this.getData('name-ja'));
		$('#school-name-en').text(this.getData('name-en'));
		$('#address').text(this.getData('address'));
		$('#establishment').text(this.getData('establishment'));
		$('#coeducation').text(coeducation);
		$('#target-age').text(this.getData('target-age'));
		$('#access').text(this.getData('access'));
		$('#number-of-student').text(this.getData('number-of-student'));
		$('#number-of-dormitory-student').text(this.getData('number-of-dormitory-student'));
		$('#international-student-percentage').text(this.getData('international-student-percentage'));
		$('#tuition-fee').text(this.getData('tuition-fee'));
		$('#curriculum').text(curriculum);
		$('#heading').html(String(this.getData('title') || '').replace(/\r?\n/g, '<br>'));
		$('#body').text(this.getData('body'));
		$('#coming-soon-name').text(this.getData('name-en'));

		this._$target.addClass('show');
		$('body').append('<div class="modal-bg"></div>');
		$('.modal-bg').on('click', () => this.modalClose());
	}

	modalClose() {
		$('body').removeAttr('style');
		$('.modal-bg').remove();
		this._$target.removeClass('show is-coming-soon has-main-image');
	}
}
